<template>
  <iframe
    v-if="isLicensesAllowed(partnerInfo)"
    :src="iframeUrl"
    class="embedded-full extranet licenses"
  ></iframe>
  <c-box v-else m="3xl">
    <c-heading as="h3">{{ $t("dialog.forbiddenOperation.title") }}</c-heading>
    <c-text mt="xl" mb="xl">{{ $t("common.blockedInfo") }}</c-text>
    <ContactPerson></ContactPerson>
  </c-box>
</template>

<script lang="ts">
import ContactPerson from "@/components/ContactPerson.vue";
import { CBox, CHeading, CText } from "@chakra-ui/vue";
import { BlockableActivity } from "@iloq/shared";
import { defineComponent } from "vue";
import { mapState } from "vuex";

export default defineComponent({
  name: "ExtranetLicenses",
  components: { CBox, CHeading, ContactPerson, CText },
  computed: {
    ...mapState({ iframeUrl: (state: any) => state.iframes.extranetLicensesUrl }),
    ...mapState("partnerInfo", {
      partnerInfo: "partnerInfo",
    }),
  },
  methods: {
    isLicensesAllowed: (partnerInfo?: any): boolean => {
      if (partnerInfo) {
        const isBlocked = (partnerInfo.blockedActivities || []).includes(
          BlockableActivity.INVOICING,
        );
        return !isBlocked;
      }
      return false;
    },
  },
});
</script>
